import { GrnItemsInfo } from "./grn-items-info.model";

export class GrnDetailsDto {
  grnId?: number;
  grnDate: any;
  InvoiceDate: any;
  grnNumber?: string;
  invoiceNumber: string;
  poId: number;
  totalQuantity?: number;
  totalDiscount: number;
  totalTax: number;
  totalCost: number;
  remarks: string;
  approvar: string;
  status?: string;
  referenceNumber?: number;
  createdUser : string;
  updatedUser ?: string;

    /**
    * @param grnId
  * @param grnDate
  * @param InvoiceDate
  * @param grnNumber?
  * @param invoiceNumber
  * @param poId
  * @param totalQuantity
  * @param totalDiscount
  * @param totalTax
  * @param totalCost
  * @param remarks
  * @param approvar
  * @param status
  * @param referenceNumber
  * @param createdAt 
  * @param createdUser 
  * @param updatedAt 
  * @param updatedUser 
  * @param versionFlag 
     */
    constructor(grnId: number,grnDate: any,InvoiceDate: any,grnNumber: string,invoiceNumber: string,poId: number,totalQuantity: number,totalDiscount: number,totalTax: number,totalCost: number,remarks: string,approvar: string,status: string,referenceNumber: number,createdUser : string,updatedUser : string,){
        this.grnId = grnId;
  this.grnDate = grnDate;
  this.InvoiceDate = InvoiceDate;
  this.grnNumber = grnNumber;
  this.invoiceNumber = invoiceNumber;
  this.poId = poId;
  this.totalQuantity = totalQuantity;
  this.totalDiscount = totalDiscount;
  this.totalTax = totalTax;
  this.totalCost = totalCost;
  this.remarks = remarks;
  this.approvar = approvar;
  this.status = status;
  this.referenceNumber = referenceNumber;
  this.createdUser  = createdUser;
  this.updatedUser  = updatedUser;
       
    }
}
